import { render } from "./TheAdminPurchaseAuthorizationList.vue?vue&type=template&id=3c7e57e8&scoped=true&ts=true"
import script from "./TheAdminPurchaseAuthorizationList.vue?vue&type=script&lang=ts"
export * from "./TheAdminPurchaseAuthorizationList.vue?vue&type=script&lang=ts"

import "./TheAdminPurchaseAuthorizationList.vue?vue&type=style&index=0&id=3c7e57e8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7e57e8"]])

export default __exports__